import { render, staticRenderFns } from "./NotificheWb.vue?vue&type=template&id=72e8059d&scoped=true"
import script from "./NotificheWb.vue?vue&type=script&lang=js"
export * from "./NotificheWb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8059d",
  null
  
)

export default component.exports